import ActionPanel from '@/components/ActionPanel';
import PageContent from '@/components/PageContent';
import { AchievementTypeEnum, UpsertAchievement, UpsertRouteAchievementType } from '@/models/achievement.model';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { Route } from '@/models/route.model';
import { upsertAchievement } from '@/services/achievement.service';
import { toastErrorMessage, toastSuccessMessage } from '@/utils/toasterMessage';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Message, PanelGroup, useToaster } from 'rsuite';



interface RouteActionsProps{
    formObject?: Route;
    fetchData: () => void;
};

const RouteActions: React.FC<RouteActionsProps> = ({formObject, fetchData}) => {
  const [loadingCreateAchievement, setLoadingCreateAchievement] = useState(false);

  const nav = useNavigate();
  const toaster = useToaster();

  const handleClickCreateAchievement = () => {
    if(!formObject) return;

    const handleYesClick = async () => {
      setLoadingCreateAchievement(true);
      try {
        const model : UpsertAchievement & UpsertRouteAchievementType = {
          name: formObject.name,
          type: AchievementTypeEnum.Routes,
          supportingCityId: formObject.cityId,
          supportingCountryId: formObject.city?.country?.id,
          routeId: formObject.id,
        };
        const result: BaseResponseModel<null> = await upsertAchievement(model);
        if (result.success) {
          toastSuccessMessage(`Achievement Successfully Created.`);
          fetchData();
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in creating Achievement:${errorModel?.errorMessage}`);
      }
      finally {
        setLoadingCreateAchievement(false);
        toaster.clear(); 
      }
    };

    const handleNoClick = () => {
      toaster.clear(); 
    };

    toaster.push(
      <Message type="info" closable>
        <p style={{marginBottom:10}}>Are you sure you want to <strong>Create Achievement</strong>?</p>
        <div>
          <Button appearance="primary" onClick={handleYesClick}>Yes</Button>
          <Button appearance="subtle" onClick={handleNoClick} style={{ marginLeft:10}}>No</Button>
        </div>
      </Message>,
      { placement: 'topCenter', duration: 0 }
    );

  };


    return (
        <PageContent>
            <PanelGroup>
                <ActionPanel
                  title='Create Achievement'
                  description='This action let create a new achievement for current route, if not already created.'
                  onClick={handleClickCreateAchievement}
                  loading={loadingCreateAchievement}
                  disabled={formObject?.hasAchievement}
                />
            </PanelGroup>
        </PageContent>
    );
};

export default RouteActions;
